<template>
  <div class="centervideo">
    <div class="centerheader">
      <div class="centerheaderul">
        <label>课件</label>
        <p class="arrowspd">></p>

        <select
          name="public-choice"
          class="selcetbox"
          v-model="parentIdOne"
          @change="getCouponSelected"
        >
          <option :value="item.id" v-for="(item,index) in mooklist" :key="index">{{item.name}}</option>
        </select>

        <p class="arrowspd">></p>
        <select
          name="public-choice"
          v-model="catalogueIdOne"
          class="selcetbox"
          @change="getCouponSelectedtwo"
        >
          <option :value="item.id" v-for="(item,index) in mooklistTwo" :key="index">{{item.name}}</option>
        </select>
      </div>
    </div>
    <div class="chape-right">
      <div class="hedvidebox">
        <li
          :class="{'current':isActive==index}"
          style="flex: 1;display: flex;justify-content: center;align-items: center;"
          v-for="(item,index) in catalist"
          :key="index"
          @click="btnvide_txt(item,index)"
        >
          <img v-if="item.type==1" src="@/assets/images/course/videplayimg.png" />
          <img v-if="item.type==2" src="@/assets/images/course/docum.png" />
          <img v-if="item.type==3" src="@/assets/images/course/exerciseimg.png" />
        </li>
      </div>

      <div class="tabx" v-if="type==1 || type==2">
        <div class="chape-right-center" v-if="type==1">
          <div style="width:900px;height:480px">
            <video-player
              :class="['vjs-custom-skin']"
              style="object-fit: cover"
              ref="videoPlayer"
              :fluid="true"
              :options="playerOptions"
              :playsinline="false"
              :fullSreen="true"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @ended="onPlayerEnded($event)"
              @timeupdate="onPlayerTimeupdate($event)"
            ></video-player>
          </div>
          <div class="next-box" v-show="visShow == 1">
            <div>
              <div class="nexpalys">即将为你打开下一个学习视频</div>
              <div class="circleclas">{{countdown}}</div>
              <div class="replayclas" @click="replay">重新播放</div>

              <!-- <el-button type="success" round v-if="accomplishflg==false" @click="replay">重新播放</el-button> -->
              <!-- <div v-if="accomplishflg==true">当前视频已看完！</div> -->
            </div>
          </div>
        </div>
        <pdflist v-if="type==2" :payurl="payurl"></pdflist>
      </div>
      <div class="tabx" v-if="type==3" style="overflow: hidden;overflow-y: auto;">
        <examinationlist v-if="type==3" :guelistCommon="guelistCommon"></examinationlist>
      </div>
    </div>
  </div>
</template>

<script>
import pdflist from '../../compoents/pdflist/index';
import examinationlist from '../../compoents/examinationlist/index';

import * as moocCatalogue from '@/api/mooc/catalogue'; //接口
import Vue from 'vue';
import VideoPlayer from 'vue-video-player';
window.videojs = VideoPlayer.videojs;
require('video.js/dist/lang/zh-CN.js');
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
import 'videojs-flash'; //引入才能播放rtmp视屏
import 'videojs-contrib-hls'; //引入才能播放m3u8文件

Vue.use(VideoPlayer);
export default {
  props: ['resourlist'],
  components: { pdflist, examinationlist },
  data() {
    return {
      passReason: '',
      sucontlist: '',
      countdown: 5,
      timer: null,
      pageIndex: 1,
      pageSize: 10,
      countlist: 0,
      accomplishflg: false,
      isGive: Boolean,
      payurl: '',
      txtVal: 0,
      desc: '',
      Selectedtwo: 0,
      parentIdOne: 0,
      catalogueIdOne: 0,

      MoocTalkLoadlist: [],
      activeName: 'second',
      type: 0,
      playerOptions: {
        objectFit: 'contain',
        height: '480px',
        size: '100%',
        autoplay: false,
        muted: false,
        language: 'en',
        webkitPlaysinline: 'true',
        language: 'zh-CN',
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        sources: [
          {
            src: '',
          },
        ],
        // /uploadfile/2021/05/11/2021051114400955.mp4
        // http://121.12.125.214:8082/uploadfile/2021/05/11/2021051114400955.mp4
        presentTiem: '',
        videoStepId: '',
      },

      visShow: 0,
      isActive: 0,
      mooklist: [],
      mooklistTwo: [],
      catalist: [],
      guelist: '',
      guelistCommon: [],
      nextVideoAdress: '',
      nextVideoId: '',
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  mounted() {
    this.passReason = this.resourlist.auditMsg;
    this.getMooklist();
  },
  methods: {
    // 审核资源 1通过0不通过
    auditResource(type) {
      let data = {
        id: this.resourlist.id,
        type: type,
        passReason: this.passReason,
      };
      moocCatalogue.MoocCourseAudit(data).then((res) => {
        console.log(res);
        this.$notify({
          title: '成功',
          message: '成功',
          type: 'success',
          duration: 2000,
        });
        let flg = false;
        setTimeout(() => {
          this.$emit('auditResou', flg);
        }, 700);
      });
    },
    // 获取课程资源列表
    getMooklist() {
      let _this = this;
      let data = { courseId: _this.resourlist.id, parentId: 0 };
      moocCatalogue.MoocGetListByPid(data).then((res) => {
        // console.log(res.result);
        let list = res.result;
        if (list.length != 0) {
          _this.parentIdOne = list[0].id;

          _this.mooklist = res.result;
          _this.getMooklistTwo();
        }
      });
    },
    // 根据父节点查询
    getMooklistTwo() {
      let _this = this;
      let data = { courseId: _this.resourlist.id, parentId: _this.parentIdOne };
      moocCatalogue.MoocGetListByPid(data).then((res) => {
        // console.log(res.result);
        let list = res.result;
        _this.catalogueIdOne = list[0].id;
        _this.mooklistTwo = res.result;
        _this.catalogueIdlist();
      });
    },
    // 查询练习题课件
    catalogueIdlist() {
      let _this = this;
      let data = {
        catalogueId: _this.catalogueIdOne,
        page: _this.pageIndex,
        limit: _this.pageSize,
      };
      moocCatalogue.catalogueId(data).then((res) => {
        // console.log(res.data);
        if (res.data.length != 0) {
          let obj = {};
          obj = {
            type: 3,
            filePath: res.data,
            id: 0,
          };

          _this.guelist = obj;
        } else {
          _this.guelist = '';
        }
        _this.GetCatalogue();
      });
    },
    // 查询课件节点下资源
    GetCatalogue() {
      let _this = this;
      let data = { catalogueId: _this.catalogueIdOne };
      moocCatalogue.GetCatalogue(data).then((res) => {
        let list = res.result;
        if (_this.guelist != '') {
          list.push(_this.guelist);
        }
        _this.catalist = list;

        _this.btnvide_txt(list[0], 0);
      });
    },

    // 文本计数器
    descInput() {
      this.txtVal = this.desc.length;
    },

    // 点击大节点查询
    getCouponSelected() {
      let _this = this;
      let data = { courseId: _this.resourlist.id, parentId: _this.parentIdOne };

      moocCatalogue.MoocGetListByPid(data).then((res) => {
        _this.mooklistTwo = res.result;

        _this.catalogueIdOne = res.result[0].id;
        let datalx = {
          catalogueId: _this.catalogueIdOne,
          page: _this.pageIndex,
          limit: _this.pageSize,
        };
        moocCatalogue.catalogueId(datalx).then((res) => {
          // console.log(res.data);
          if (res.data.length != 0) {
            let obj = {};
            obj = {
              type: 3,
              filePath: res.data,
              id: 99,
            };
            _this.guelist = obj;
          } else {
            _this.guelist = '';
          }
          // 查询当前选中下面的资源
          let datas = { catalogueId: _this.catalogueIdOne };
          moocCatalogue.GetCatalogue(datas).then((res) => {
            let list = res.result[0];
            let listArry = res.result;
            if (listArry.length != 0) {
              if (_this.guelist != '') {
                listArry.push(_this.guelist);
              }
              _this.catalist = listArry;

              _this.btnvide_txt(list, 0);
            }
          });
        });
      });
    },

    // 点击第二节点
    getCouponSelectedtwo() {
      let _this = this;
      // 查询当前下面有没有练习题
      let datalx = {
        catalogueId: _this.catalogueIdOne,
        page: _this.pageIndex,
        limit: _this.pageSize,
      };
      moocCatalogue.catalogueId(datalx).then((res) => {
        // console.log(res.data);
        if (res.data.length != 0) {
          let obj = {};
          obj = {
            type: 3,
            filePath: res.data,
            id: 0,
          };
          _this.guelist = obj;
        } else {
          _this.guelist = '';
        }
        // 查询当前选中下面的资源
        let datas = { catalogueId: _this.catalogueIdOne };
        moocCatalogue.GetCatalogue(datas).then((res) => {
          let list = res.result[0];
          let listArry = res.result;
          if (listArry.length != 0) {
            if (_this.guelist != '') {
              listArry.push(_this.guelist);
            }
            _this.catalist = listArry;

            _this.btnvide_txt(list, 0);
          }
        });
      });
    },

    // 点击资源
    palyerVideoAdtext() {},

    // 点击播放资源
    btnvide_txt(sucont, index) {
      let _this = this;
      _this.visShow = 0;
      _this.isActive = index;
      _this.sucontlist = sucont; //当前播放的资源数据
      _this.sourceId = sucont.id; //资源id赋值浏览器
      // console.log(sucont);
      // console.log('点击数据');
      if (sucont.type == 1) {
        _this.type = 1;
        _this.playCommon(sucont.filePath);
      } else if (sucont.type == 2) {
        _this.payurl = sucont.filePath;
        _this.type = 2;
      } else if (sucont.type == 3) {
        _this.guelistCommon = sucont.filePath;
        _this.type = 3;
      } else if (sucont.type == 4) {
        _this.type = 4;
      } else if (sucont.type == 5) {
        _this.type = 5;
      }
    },
    // 播放公用
    playCommon(adressSum) {
      let _this = this;
      this.$nextTick(() => {
        console.log(_this.$refs['videoPlayer']);
        _this.playerOptions.sources[0].src = adressSum;
        _this.$refs['videoPlayer'].options.autoplay = true;
        _this.$refs['videoPlayer'].player.play();
      });
    },
    // 重新播放
    replay() {
      let _this = this;
      _this.visShow = 0;

      _this.playerOptions.sources[0].src = _this.sucontlist.filePath;
      _this.$refs.videoPlayer.options.autoplay = true;
      _this.$refs.videoPlayer.player.play();
    },

    // 视频的功能-------------------------
    onPlayerPlay(player) {},
    // 视频暂停
    onPlayerPause(player) {},
    // 视频结束事件
    onPlayerEnded(player) {
      // console.log(this.$refs.videoPlayer.player.currentTime());
      // console.log('结束');
      // this.sendCode();
      this.serchNexVideo();
    },
    // 查找下一个视频
    serchNexVideo() {
      this.countdown = 5;
      for (let i = Number(this.isActive) + 1; i < this.catalist.length; i++) {
        if (this.catalist[i].type == 1) {
          if (this.catalist[i].id != this.sucontlist.id) {
            this.visShow = 1;
            // this.isActive = i;
            this.nextVideoId = i;
            this.nextVideoAdress = this.catalist[i].filePath;
            this.sendCode();
            return false;
          }
        } else {
          this.visShow = 0;
        }
      }
    },
    //监听播放器时间
    onPlayerTimeupdate(player) {
      this.gklog = player.currentTime();
    },

    //倒计时
    sendCode() {
      this.loading(); //启动定时器
      this.timer = setInterval(() => {
        //创建定时器
        if (this.countdown === 1) {
          this.clearTimer(); //关闭定时器
          // this.serchNexVideo();
          this.visShow = 0;
          this.isActive = this.nextVideoId;
          this.playCommon(this.nextVideoAdress);
        } else {
          this.loading();
        }
      }, 1000);
    },
    loading() {
      //启动定时器
      this.countdown--; //定时器减1
    },
    clearTimer() {
      //清除定时器
      clearInterval(this.timer);
      this.timer = null;
    },
    // 页面销毁的时候插入记录
    beforeDestroy() {
      window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e));
    },
  },
};
</script>

<style lang="scss" scoped>
.centervideo {
  padding-bottom: 50px;
  .chape-right {
    // width: 1100px;
    margin: 0 auto;
    height: 600px;
    .chape-right-header {
      .el-menu {
        display: flex;
        justify-content: space-between;
        border: none;
        padding: 15px 0;
        .el-menu-item {
          height: 30px;
          flex: 1;
          margin-right: 5px;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(127, 127, 127, 1);
          .el-icon-menu {
            height: 25px;
          }
        }
      }
      .tabul {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 34px;
        > li {
          width: 266px;
          background-color: #7f7f7f;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(127, 127, 127, 1);
          border-radius: 5px;
          .tabimg {
            width: 25px;
            height: 25px;
          }
          &:hover {
            background-color: #adaaaa46;
          }
        }
        .active {
          background-color: rgba(112, 182, 3, 1);
        }
      }
    }
    .chape-right-center {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }
  }
}

.commentbox {
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;

  .commennumber {
    font-weight: bold;
    font-size: 18px;
  }
  .commentaret {
    width: 100%;
    height: 150px;
    border: 1px solid rgba(215, 215, 215, 1);
    border-radius: 3px;
    margin-top: 15px;
    font-size: 16px;
    padding: 5px;
    letter-spacing: 1px;
  }
  .commenbtn {
    display: flex;
    align-items: center;
    margin-top: 10px;
    .commentText {
      flex: 1;
      text-align: right;
      padding-right: 20px;
    }
    .commentbtnst {
      height: 40px;
      width: 100px;
      color: #f7f7f7;
      background-color: #d7d7d7;
      text-align: center;
      line-height: 40px;
      border-radius: 5px;
    }
  }
}

.tabx {
  // height: 540px;
  // width: 1200px;
  margin-top: 15px;
  position: relative;
}
.next-box {
  position: absolute;
  z-index: 999;
  border-radius: 20px;
  width: 100%;
  height: 480px;
  color: #fff;
  background-color: rgb(8, 8, 8);
  // line-height: 600px;
  text-align: center;
  border-radius: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hedvidebox {
  display: flex;
  height: 30px;
  background-color: #f0f0f0;
  margin-top: 15px;
  img {
    width: 20px;
    height: 20px;
  }
  .hedvide:hover {
    background-color: #00c758;
  }
  .current {
    background-color: #00c758;
  }
}

.centerheader {
  height: 55px;
  background-color: #888;
  display: flex;
  align-items: center;
}
.centerheaderul {
  margin: 0 auto;
  width: 1200px;
  display: flex;
  align-items: center;
}
.selcetbox {
  width: 180px;
  height: 30px;
  border-radius: 3px;
}
.centerheaderul label {
  font-size: 20px;
  font-weight: 700;
}
.arrowspd {
  margin: 0 20px;
}
.txtds {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  height: 540px;
  overflow: hidden;
  overflow-y: auto;
}
.txtdsbox {
  padding: 10px;
  background-color: #efefef;
  border-radius: 5px;
  font-size: 15px;
  width: 800px;
  margin: 0 auto;
}
.txtds p {
  line-height: 30px;
}

.circleclas {
  height: 80px;
  width: 80px;
  border: 2px solid #3d3d3d;
  border-radius: 50%;
  text-align: center;
  line-height: 80px;
  font-size: 24px;
  margin: 0 auto;
  margin-top: 20px;
}
.replayclas {
  color: #8cb822;
  font-size: 18px;
  margin-top: 20px;
}
.nexpalys {
  font-size: 28px;
}

video::cue(.red) {
  color: red;
}
video::cue(.blue) {
  color: blue;
}
video::cue(.green) {
  color: green;
}
video::cue(.yellow) {
  color: yellow;
}
video::cue(.background-red) {
  background-color: red;
}
video::cue(.background-blue) {
  background-color: blue;
}
video::cue(.background-green) {
  background-color: green;
}
video::cue(.background-yellow) {
  background-color: yellow;
}
video::cue(.font-family-Georgia) {
  font-family: Georgia;
}
video::cue(.font-style-italic) {
  font-style: italic;
}
video::cue(.font-size-60) {
  font-size: 60px;
}
video::cue(.font-size-12) {
  font-size: 40px;
}
video::cue(.text-decoration-underline) {
  text-decoration: underline;
}
video::cue(.text-decoration-underline-color) {
  border-bottom: 3px solid #00f;
  color: #090;
}
video::cue(.text-shadow) {
  font-size: 40px;
  text-shadow: -1px 0 #f00, 0 -1px #f00, 1px 0 #f00, 0 1px #f00;
}
video::cue(.outline) {
  outline: #00ff00 dotted thick;
}
video::cue(.webkit-text-stroke) {
  font-size: 40px;
  -webkit-text-stroke: 2px #ff75bf;
}
</style>

